import { BlockStack, RadioButton } from "@shopify/polaris";
import { useCallback } from "react";

interface BlockingModeProps {
  update: (value: string) => void;
  value: string | undefined;
}

export const BlockingMode = ({ update, value }: BlockingModeProps) => {
  const handleChange = useCallback((_event: unknown, newValue: string) => {
    update(newValue);
  }, []);

  return (
    <BlockStack gap="400">
      <RadioButton
        checked={value === "disabled"}
        id="disabled"
        label="Disabled"
        name="blockingMode"
        onChange={handleChange}
      />
      <RadioButton
        checked={value === "blockmax"}
        helpText="Block injected codes during the entire check out session and prevent any discount code from being injected from leak sites."
        id="blockmax"
        label="Maximum Blocking"
        name="blockingMode"
        onChange={handleChange}
      />
      <RadioButton
        checked={value === "blocksession"}
        helpText="Block injected (apply codes button) codes during the entire check out session. Will also prevent copy and pasting from coupon extensions."
        id="blocksession"
        label={
          <p>
            Strong Blocking <b>(Recommended)</b>
          </p>
        }
        name="blockingMode"
        onChange={handleChange}
      />
      <RadioButton
        checked={value === "blockonce"}
        helpText="Block codes when injected (apply codes button) only. Allows user to enter codes manually after."
        id="blockonce"
        label="Basic Blocking"
        name="blockingMode"
        onChange={handleChange}
      />
      <RadioButton
        checked={value === "tracking"}
        helpText="Track discount codes when they are injected (apply codes button) only"
        id="tracking"
        label="Tracking only"
        name="blockingMode"
        onChange={handleChange}
      />
    </BlockStack>
  );
};
